/** Custom URL scheme registered by the Progress mobile app. */
export const APP_SCHEME = "progress";

/** Splits a React Router splat (`*` param) into usable path segments. */
export function splatToSegments(splat: string | undefined): string[] {
  return (splat ?? "").split("/").filter(Boolean);
}

function joinSegments(segments: string[]): string {
  return segments.filter(Boolean).join("/");
}

function withQueryAndHash(base: string, search: string, hash: string): string {
  const query = search.replace(/^\?/, "");
  const fragment = hash.replace(/^#/, "");
  return `${base}${query ? `?${query}` : ""}${fragment ? `#${fragment}` : ""}`;
}

/** Native app deep link, e.g. `progress://profile?ref=web#top`. */
export function buildDeepLink(
  segments: string[],
  search: string,
  hash: string,
): string {
  return withQueryAndHash(
    `${APP_SCHEME}://${joinSegments(segments)}`,
    search,
    hash,
  );
}

/** Where to send visitors whose device could not open the app. */
export function buildWebFallback(
  segments: string[],
  search: string,
  hash: string,
): string {
  const path = joinSegments(segments);
  return withQueryAndHash(path ? `/${path}` : "/", search, hash);
}
